import { Image, ImageProps, Box, useColorModeValue } from '@chakra-ui/react';
import logoImage from '../assets/images/HansCard.svg';

type LogoWithBackgroundProps = Omit<ImageProps, 'src'> & {
  withBackground?: boolean;
};

/**
 * Logo component that applies a specific background color in light mode
 */
const LogoWithBackground = ({ withBackground = true, ...props }: LogoWithBackgroundProps) => {
  const bgColor = useColorModeValue('#2e2e4c', 'transparent');
  const logoFilter = useColorModeValue('none', 'brightness(1.2)');

  return (
    <Box position="relative" display="inline-block">
      <Image
        src={logoImage}
        alt="Hans Card"
        filter={logoFilter}
        style={{
          backgroundColor: withBackground ? bgColor : 'transparent',
          borderRadius: '6px'
        }}
        {...props}
      />
    </Box>
  );
};

export default LogoWithBackground;